import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IBillRecordItem, defaultValue } from 'app/shared/model/bill-record-item.model';
// 定义请求
export const ACTION_TYPES = {
  FETCH_BILLRECORDITEM_LIST: 'billRecordItem/FETCH_BILLRECORDITEM_LIST',
  FETCH_BILLRECORDITEM: 'billRecordItem/FETCH_BILLRECORDITEM',
  CREATE_BILLRECORDITEM: 'billRecordItem/CREATE_BILLRECORDITEM',
  UPDATE_BILLRECORDITEM: 'billRecordItem/UPDATE_BILLRECORDITEM',
  DELETE_BILLRECORDITEM: 'billRecordItem/DELETE_BILLRECORDITEM',
  RESET: 'billRecordItem/RESET'
};
// state类型
const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IBillRecordItem>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type BillRecordItemState = Readonly<typeof initialState>;

// Reducer

export default (state: BillRecordItemState = initialState, action): BillRecordItemState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_BILLRECORDITEM_LIST):
    case REQUEST(ACTION_TYPES.FETCH_BILLRECORDITEM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_BILLRECORDITEM):
    case REQUEST(ACTION_TYPES.UPDATE_BILLRECORDITEM):
    case REQUEST(ACTION_TYPES.DELETE_BILLRECORDITEM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_BILLRECORDITEM_LIST):
    case FAILURE(ACTION_TYPES.FETCH_BILLRECORDITEM):
    case FAILURE(ACTION_TYPES.CREATE_BILLRECORDITEM):
    case FAILURE(ACTION_TYPES.UPDATE_BILLRECORDITEM):
    case FAILURE(ACTION_TYPES.DELETE_BILLRECORDITEM):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_BILLRECORDITEM_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_BILLRECORDITEM):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_BILLRECORDITEM):
    case SUCCESS(ACTION_TYPES.UPDATE_BILLRECORDITEM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_BILLRECORDITEM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/bill-record-items';

// Actions

export const getEntities: ICrudGetAllAction<IBillRecordItem> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_BILLRECORDITEM_LIST,
  payload: axios.get<IBillRecordItem>(`${apiUrl}?cacheBuster=${new Date().getTime()}`)
});

export const getEntity: ICrudGetAction<IBillRecordItem> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_BILLRECORDITEM,
    payload: axios.get<IBillRecordItem>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IBillRecordItem> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_BILLRECORDITEM,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IBillRecordItem> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_BILLRECORDITEM,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IBillRecordItem> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_BILLRECORDITEM,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
